// extracted by mini-css-extract-plugin
export default {"recos":"k9-z","productCardOverride":"l9-z","rowHasBadge":"m9-z"};